
require.register("core-js/library/modules/_iter-step.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "core-js");
  (function() {
    module.exports = function (done, value) {
  return { value: value, done: !!done };
};
  })();
});